import {
  Button,
  Card,
  CardContent,
  CardMedia,
  Collapse,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { Link } from "react-router-dom";

const useStyles = makeStyles({
  root: {
    maxWidth: 250,
    margin: "20px",
  },
  media: {
    height: 200,
  },
  title: {
    fontFamily: "Nunito",
    fontWeight: "bold",
    fontSize: "1.5rem",
  },
  desc: {
    fontFamily: "Nunito",
    fontSize: "1.1rem",
  },
  viewMoreButton: {
    margin: "20px",
  },
});

export default function ServicesCard(props) {
  const { service, checked, setCurrPage, viewMore } = props;
  const classes = useStyles();

  return (
    <Collapse in={checked} {...(checked ? { timeout: 1000 } : {})}>
      {viewMore ? (
        <Button
          className={classes.viewMoreButton}
          variant="contained"
          color="primary"
          component={Link}
          to={"/services"}
          onClick={() => setCurrPage("Services")}
        >
          View All services
        </Button>
      ) : (
        <Card className={classes.root}>
          <CardMedia className={classes.media} image={service.imageURL} />
          <CardContent>
            <Typography
              gutterBottom
              variant="h5"
              component="h2"
              className={classes.title}
            >
              {service.name}
            </Typography>
            <Typography
              variant="body2"
              color="textSecondary"
              component="p"
              className={classes.desc}
            >
              {service.description}
            </Typography>
          </CardContent>
        </Card>
      )}
    </Collapse>
  );
}
